<template>
  <form method="post" action="#" @submit="submit">
    <div class="chatInputWrapper">
      <input
          class="chatInputField"
          :placeholder="placeholder"
          required="true"
          v-model="textInput"
          ref="input" />
      <button type="submit" class="chatInputPrimaryButton" v-on:click.native="submit">
        <chat-send-button></chat-send-button>
      </button>
    </div>
  </form>
</template>

<script>

  import ChatSendButton from "@/components/buttons/ChatSendButton";
  export default {
    name: 'ChatInputField',
    components: {
      ChatSendButton
    },
    props: {
      text: String,
      placeholder: String,
    },
    data() {
      return {
      }
    },

    computed: {
      textInput: {
        get: function(){
          return this.text;
        },
        set: function(newValue){
          this.$emit('update:text', newValue)
        }
      },
    },
    methods: {

      submit(e) {
        e.preventDefault();
        this.$emit('submit');
      }

    },

    created() {

    }
  }
</script>

<style lang="scss">
@import "src/assets/scss/variables";
  .chatInputWrapper {
    margin: $primaryMargin;
    background: #FFFFFF;
    border-radius: 15px;
    height: $primaryInputHeight;
    font-size: $secondaryTextFontSize;
    display: flex;
    max-width: 91.4666667vw;
  }

  .chatInputField {
    height: 100%;
    border-radius: 15px 0 0 15px;
    padding-left: 1.125rem;
    flex-grow: 1;
    outline: none;
  }

  .chatInputField:active {
    outline: none;
  }

</style>
